export const isNavigationItemActive = (
  value: number | string | undefined,
  selectedValue: number | string | undefined
): boolean => String(value) === String(selectedValue);
